var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseListV2',{attrs:{"model-class":_vm.Channel,"can-copy":true,"help-message":'Represents a firmware release channel.'}})}
var staticRenderFns = []

export { render, staticRenderFns }